import React from 'react';
import {ServerComponentCaller} from "../../helpers";

const LicenciaClaseA3 = props => <ServerComponentCaller url={"assets/data/pages/licencias/A3.json"}/>


export default LicenciaClaseA3;
